import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from '../dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface DialogData {
  patid: string;
  userid: number;
  uhid: number;
}

@Component({
  selector: 'app-finish-dilation',
  templateUrl: './finish-dilation.component.html',
  styleUrls: ['./finish-dilation.component.css']
})
export class FinishDilationComponent implements OnInit {
  destroyfinish$: Subject<boolean> = new Subject<boolean>();
  constructor(private authService: AuthService, private dialogRef: MatDialogRef<FinishDilationComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData, private dashboardService: DashboardService,
    private translate: TranslateService,
    private langservice: LanguageService,) {
    dialogRef.disableClose = true;
    translate.addLangs(['en', 'fr', 'hi']);
    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    }
    else {
      translate.setDefaultLang('en');
    }
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    this.destroyfinish$.next(true);
    this.destroyfinish$.unsubscribe();
  }
  onNoClick(): void {
    this.dashboardService.popup_cancel = true;
    this.dialogRef.close();
  }

  finishdilation() {
    this.dashboardService.popup_cancel = false;
    this.getdilationstatus();
    this.getdilation();
  }

  getdilationstatus() {
    this.dashboardService.getdialationStart(this.data.patid, this.dashboardService.currenttime, this.dashboardService.dilationwith, this.dashboardService.selectedeye, this.authService.Loggeduser.userid, 'finish',this.dashboardService.finishtime).pipe(takeUntil(this.destroyfinish$))
    .subscribe(data => this.success_dilation_finish(data),
      err => this.failed_dilation(err));
  }

  success_dilation_finish(data) {
    console.log("Dilation Finished");
    this.dialogRef.close();
  }
  failed_dilation(err) {
    this.dialogRef.close();
    if(err.status==403){
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }else{
      this.dashboardService.openSnackBar("Dilation Finished Fail", "OK");
    }
  }
  getdilation() {
    this.dashboardService.getDailationstart(this.data.patid, this.authService.Loggeduser.userid, 'finish').pipe(takeUntil(this.destroyfinish$))
      .subscribe(data => this.success_dilation(data),
        err => this.failed_dilation_msg(err));
  }
  success_dilation(data) {

    this.dialogRef.close();
  }

  failed_dilation_msg(err) {
    this.dialogRef.close();
    if(err.status==403){
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }else{
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
}
